import { SafeString } from '@fragment/types/strings';
import baseX from 'base-x';
import objectHash from 'object-hash';

const alphabet =
  '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

const base62 = baseX(alphabet);

const deterministicId = (data: Record<string, unknown>): SafeString => {
  // sort the keys so that key ordering doesn't matter
  const bytes = objectHash(data, { encoding: 'buffer', algorithm: 'sha1' });
  // we use a custom version of base62 so that these IDs visibly resemble `lilId`s
  // but are generated deterministically using a sha-1 hash. These are not
  // cryptographically secure hashes, they are only intended to be deterministic.
  return base62.encode(bytes).slice(0, 21) as SafeString;
};

export default deterministicId;
